import React, { useContext, useEffect, useState } from "react";
import { Input, Button, Row, Col, Label } from "reactstrap";
import { FormField } from "../../../../../utils";
import { Dispatch } from "../../store/store";
import style from "../Bulk/Bulk.module.scss";
import Symbol from "../../Fields/Symbol";
import { Combobox, Field, Numeric } from "../../../Order/Field/Field";
import { CurrencyAsset, IOType } from "../../../../IO/types";
//import { Denominations } from "../../../../Asset/Tabs/Denominations/Denominations";

const Edit = ({ accountId, toggle, item, edit, fetchSearchSymbol, fetchGetAssetInformation }) => {
  const [fields, setFields] = useState(item || {});
  const [errors, setErrors] = useState({});
  const [decimalAmount, setDecimalAmount] = useState();
  const { dispatch, services, state } = useContext(Dispatch);
  const { io } = state;

  const [balance, setBalance] = useState({
    loading: false,
    data: [],
  });
  const simpleItem = fields;
  const [denominations, setDenominations] = useState([]);
  const [denominationsReturn, setDenominationsReturn] = useState([]);
  const [assetDenominationInfo, setAssetDenominationInfo] = useState({ AssetPhysicalDenomination: false });
  const [segundoFetch, setSegundoFetch] = useState();
  const [asset, setAsset] = useState([]);
  const onChange = (newFields) => {
    setFields({
      ...fields,
      ...newFields,
    });
    const cleanedErrors = {};

    Object.keys(newFields).forEach((key) => (cleanedErrors[key] = undefined));

    setErrors({
      ...errors,
      ...cleanedErrors,
    });
    //console.log(fields);
  };

  const onEdit = () => {
    let newErrors = {};

    if (fields.Quantity == undefined || fields.Quantity === "") {
      newErrors["Quantity"] = "Required field";
    }
    if (fields.denominationsTrue == false) {
      newErrors["Denominations"] = "Must select " + fields.slots + " denominations for the quantity selected";
    }
    if (fields.IsCurrency) {
      if (fields.CurrencyId == undefined || fields.CurrencyId == "") {
        newErrors["CurrencyISO"] = "Required field";
      }
    } else {
      if (fields.AssetId == undefined || fields.AssetId == "") {
        newErrors["AssetTicker"] = "Required field";
      }
    }

    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
    } else {
      edit({
        ...item,
        ...fields,
      });
      toggle();
    }
  };

  useEffect(() => {
    if (fields.AssetId) {
      fetchGetAssetInformation({ assetId: fields.AssetId }).then((response) => {
        setAsset(response.info);
      });
    }
  }, [fields.AssetId]);

  useEffect(() => {
    if (simpleItem.AssetId != 0) {
      services
        .GetDenominations({
          AssetId: simpleItem.AssetId,
          AccountId: accountId,
          WithdrawId: 0,
          DepositId: 0,
          itemId: 0,
          TransferId: 0,
        })
        .then((response) => {
          let responseDenominations = response.denominations;
          for (let i = 0; i < io.items.length; i++) {
            let currentItemDenominations = io.items[i].Denominations;
            if (item.Denominations !== undefined) {
              if (
                !item.Denominations.some((obj2) =>
                  currentItemDenominations.some((obj1) => obj1.DenominationId === obj2.DenominationId)
                )
              ) {
                responseDenominations = responseDenominations.filter(
                  (element) =>
                    !currentItemDenominations.some((obj2) => obj2.DenominationId === element.DenominationId)
                );
              }
            } else {
              responseDenominations = responseDenominations.filter(
                (element) =>
                  !currentItemDenominations.some((obj2) => obj2.DenominationId === element.DenominationId)
              );
            }
          }
          setDenominations(responseDenominations);
          onChange({
            DenominationsTotal: responseDenominations,
            slots: 0,
          });
          setSegundoFetch(true);
        });
    }
  }, [simpleItem.AssetId, accountId]);

  useEffect(() => {
    if (io.Id !== undefined && fields.Denominations === undefined) {
      services
        .GetDenominations({
          AssetId: fields.AssetId,
          AccountId: accountId,
          WithdrawId: -1,
          DepositId: -1,
          itemId: fields.Id,
          TransferId: io.Id,
        })
        .then((response) => {
          const responseDenominations = response.denominations;
          //console.log(responseDenominations);
          //setDenominations(responseDenominations);
          onChange({
            Denominations: responseDenominations,
          });
        });
    }
  }, [segundoFetch]);

  useEffect(() => {
    if (accountId && !fields.IsCurrency && simpleItem.AssetId) {
      setBalance({ ...balance, loading: true });
      services
        .fetchAccountSellingPower({ accountId: accountId, assetId: simpleItem.AssetId })
        .then((response) => {
          const { sellingpower } = response.response;
          setBalance({ ...balance, data: sellingpower });
        });
    } else {
      setBalance({ ...balance, data: [] });
    }
    setBalance({ ...balance, loading: false });
    services.fetchGetAssetInformation({ assetId: simpleItem.AssetId }).then((response) => {
      if (response.info.AssetPhysicalDenomination) {
        setAssetDenominationInfo({
          AssetPhysicalDenomination: response.info.AssetPhysicalDenomination,
          AssetSheetSize: response.info.AssetSheetSize,
          SlotsQuantity: 0,
        });
      } else {
        setAssetDenominationInfo({
          AssetPhysicalDenomination: false,
          AssetSheetSize: 0,
          SlotsQuantity: 0,
        });
      }
      //console.log("response:", response.info);
      //setDecimalAmount(response.info.SubAssetClassDecimalPlaces);
    });
  }, [simpleItem.AssetId]);

  useEffect(() => {
    if (assetDenominationInfo.AssetPhysicalDenomination && fields.Quantity) {
      let slots = Math.ceil(fields.Quantity / assetDenominationInfo.AssetSheetSize);
      setAssetDenominationInfo({
        ...assetDenominationInfo,
        SlotsQuantity: slots,
      });
      let i;
      if (slots > denominationsReturn.length) {
        //selecciono menos denominations de los marcados en cantidad
        i = false;
      } else if (slots < denominationsReturn.length) {
        //seleciono mas denominations de los marcados en cantidad
        i = false;
      } else {
        i = true;
      }
      onChange({
        denominationsTrue: i,
        slots: slots,
      });
    }
  }, [fields.Quantity, denominationsReturn.length]);

  const onChangeDenomination = (checked, value, index) => {
    let denominationResult = denominationsReturn;
    if (checked) {
      denominationsReturn.push({ key: index, DenominationId: value });
    } else {
      const updatedDenomination = denominationsReturn.filter((item) => item.key !== index);
      setDenominationsReturn(updatedDenomination);
      denominationResult = updatedDenomination;
    }
    onChange({
      Denominations: denominationResult,
    });
  };
  useEffect(() => {
    if (fields.AssetId) {
      setDecimalAmount(asset.SubAssetClassDecimalPlaces);
    }
  }, [fields.Price]);

  return (
    <div className={style.edit}>
      <div>
        <Field label={"Type"}>
          <Combobox
            darken
            disabled={false}
            onChange={(v) => onChange({ IsCurrency: v == CurrencyAsset.Cash })}
            value={fields.IsCurrency ? CurrencyAsset.Cash : CurrencyAsset.Asset}
            items={Object.values(CurrencyAsset).map((key, index) => ({ id: key, description: key }))}
          />
        </Field>
        {/* ##### Quantity ###### */}
        <Field label={"Quantity"} error={errors.Quantity}>
          <Numeric
            value={parseFloat(fields.Quantity).toFixed(fields.decimal || 2)}
            placeholder={"Quantity"}
            dataTypeDecimalName="quantity"
            onChange={(v) => onChange({ Quantity: v })}
            invalid={!!errors.Quantity}
          />
        </Field>

        {/* ##### Price ###### */}
        <Field label={"Price"} error={errors.Price}>
          <Numeric
            value={parseFloat(fields.Price).toFixed(5)}
            placeholder={"Price"}
            onChange={(v) => onChange({ Price: v })}
            invalid={!!errors.Price}
            decimalScale={decimalAmount}
            dataTypeDecimalName="price"
          />
        </Field>

        {/* ##### Symbol ###### */}
        <Symbol
          ioType={IOType.Transfer}
          accountId={accountId}
          isCurrency={fields.IsCurrency}
          onChange={(values) => onChange(values)}
          error={fields.IsCurrency ? errors.CurrencyISO : errors.AssetTicker}
          disabled={false}
          value={fields.IsCurrency ? fields.CurrencyISO : fields.AssetTicker}
          fetchSearchSymbol={fetchSearchSymbol}
        />
        <Field>
          {assetDenominationInfo.AssetPhysicalDenomination && (
            <div style={{ width: "100%", marginTop: "0px", paddingTop: "0px" }}>
              <hr />
              <label
                style={{ fontSize: "15px", fontWeight: "bold", justifyContent: "center", display: "flex" }}
              >
                Denomination
              </label>{" "}
              {!fields.denominationsTrue && <Field noLabel error={errors.Denominations}></Field>}
              <hr style={{ border: "1px solid #ccc" }} />
              <div>
                {segundoFetch &&
                  denominations.map((denomination, key) => (
                    <div key={key}>
                      <Row className="align-items-center mb-3">
                        <Col md="auto">
                          <Input
                            checked={
                              fields.Denominations == undefined
                                ? false
                                : fields.Denominations.some(
                                    (item) => item.DenominationId == denomination.DenominationId
                                  )
                            }
                            key={key}
                            type="checkbox"
                            style={{
                              position: "relative",
                              cursor: "pointer",
                              left: "25px",
                            }}
                            onChange={(e) =>
                              onChangeDenomination(e.target.checked, denomination.DenominationId, key)
                            }
                          />
                        </Col>

                        <Col md="auto">
                          <Label style={{ marginLeft: "5px" }}>{denomination.DenominationTicker}</Label>
                        </Col>
                      </Row>
                      <hr />
                    </div>
                  ))}
                <hr />
              </div>
            </div>
          )}
        </Field>
      </div>

      <div className={style.actions} style={{ width: "100%" }}>
        <Button className={"btn-sm"} color="light" onClick={toggle}>
          {true ? "Cancel" : "Close"}
        </Button>{" "}
        <Button className={"primary btn-sm"} color="primary" onClick={() => onEdit()}>
          {item.Id ? "Edit" : "Add"}
        </Button>
      </div>
    </div>
  );
};

export default Edit;
